import React from 'react';
import { Modal } from '@mantine/core';

/**
 * Aperçu plein format d'un média — banque et champ média.
 *
 * Une vignette de sidebar fait 68 px de haut et un aperçu de champ 110 px :
 * ni l'un ni l'autre ne permet de reconnaître une photo de chantier, encore
 * moins de regarder une vidéo. Les deux ouvrent donc la même fenêtre, avant
 * comme après la sélection.
 *
 * La vidéo n'est jouée qu'ici : lire chaque vidéo dans la grille de la banque
 * chargerait des dizaines de mégaoctets pour ouvrir un panneau.
 */
export default function MediaPreviewModal({ opened, onClose, kind, src, poster, title }) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title || 'Aperçu'}
      centered
      size="lg"
      withinPortal
    >
      {kind === 'video' ? (
        <video
          src={src}
          poster={poster || undefined}
          controls
          autoPlay
          style={{ width: '100%', maxHeight: '70vh', background: '#000' }}
        />
      ) : (
        <img
          src={src}
          alt={title || ''}
          style={{ width: '100%', maxHeight: '70vh', objectFit: 'contain', display: 'block' }}
        />
      )}
    </Modal>
  );
}
